














































































































































































































































































































































import { IResponseElement, Pagination, SolicitudFiltroModel, SolicitudInterface } from '@/models'
import store from '@/store'
import useAppConfig from '@core/@app-config/useAppConfig'
import useSweetAlert from '@core/plugins/sweetalert'
import { formatDateTime } from '@core/utils/filter'
import {
  mdiAlertDecagramOutline,
  mdiBellRingOutline,
  mdiChevronDown,
  mdiChevronUp,
  mdiClipboardCheckOutline,
  mdiCloseOctagonOutline,
  mdiDotsVertical,
  mdiFileEditOutline,
  mdiFilterVariantMinus,
  mdiSendOutline,
} from '@mdi/js'
import PaginationFooter from '@shared/components/PaginationFooter.vue'
// Shared
import PaginationSelect from '@shared/components/PaginationSelect.vue'
import { computed, defineComponent, onMounted, ref } from '@vue/composition-api'
import BandejaSolicitudEditarModal from '../components/BandejaSolicitudEditarModal.vue'
// Components
import BandejaSolicitudFiltro from '../components/BandejaSolicitudFiltro.vue'
import BandejaSolicitudVerificarModal from '../components/BandejaSolicitudVerificarModal.vue'

export default defineComponent({
  // type inference enabled
  components: {
    PaginationSelect,
    PaginationFooter,
    BandejaSolicitudFiltro,
    BandejaSolicitudEditarModal,
    BandejaSolicitudVerificarModal,
  },
  setup() {
    const ascending = ref(false)
    const sortColumn = ref('')
    const isFilterPanelActive = ref(false)
    const mostrarVerificarModal = ref(false)
    const mostrarEditarModal = ref(false)
    const filtro = ref(new SolicitudFiltroModel())
    const pagination = ref(new Pagination())
    const solicitudes = ref<SolicitudInterface[]>([])

    const { isLoading } = useAppConfig()
    const { confirm, showMessage, showPrompt } = useSweetAlert()
    const filterDate = computed(() => (ISODate: string | Date | null | undefined) => formatDateTime(ISODate))

    onMounted(() => {
      obtenerSolicitudes(filtro.value)
    })

    const obtenerSolicitudes = async (filter: SolicitudFiltroModel) => {
      filtro.value = filter
      const params = { ...filtro.value, start: filtro.value.start - 1 }

      isLoading.value = true
      const { ok, response } = await store.dispatch('bandejaSolicitud/obtenerSolicitudes', params)

      if (ok) {
        console.log('response', response)
        solicitudes.value = response.elements
        actualizarPaginacion(response)
      }

      isLoading.value = false
    }

    const actualizarPaginacion = (response: IResponseElement<SolicitudInterface>) => {
      pagination.value.setPagination(filtro.value.start, filtro.value.limit, response.totalCount)
      filtro.value.start = pagination.value.number
    }

    const sortTable = (col: string) => {
      if (sortColumn.value === col) {
        ascending.value = !ascending.value
      } else {
        ascending.value = true
        sortColumn.value = col
      }

      const newAscending = ascending.value

      solicitudes.value = solicitudes.value.sort(function (a: SolicitudInterface | any, b: SolicitudInterface | any) {
        if (a[col] > b[col]) {
          return newAscending ? 1 : -1
        } else if (a[col] < b[col]) {
          return newAscending ? -1 : 1
        }

        return 0
      })
    }

    const editar = async (solicitud: SolicitudInterface) => {
      isLoading.value = true
      mostrarEditarModal.value = true
      const { ok } = await store.dispatch('bandejaSolicitud/obtenerSolicitud', solicitud.solicitudId)

      if (!ok) {
        mostrarEditarModal.value = false
      }
      isLoading.value = false
    }

    const editarModalOnClose = (actualizar: boolean) => {
      mostrarEditarModal.value = false
      if (actualizar) {
        obtenerSolicitudes(filtro.value)
      }
    }

    const verificar = async (solicitud: SolicitudInterface) => {
      isLoading.value = true
      mostrarVerificarModal.value = true
      const { ok } = await store.dispatch('bandejaSolicitud/obtenerSolicitud', solicitud.solicitudId)

      if (!ok) {
        mostrarVerificarModal.value = false
      }
      isLoading.value = false
    }

    const verificarModalOnClose = (actualizar: boolean) => {
      mostrarVerificarModal.value = false
      if (actualizar) {
        obtenerSolicitudes(filtro.value)
      }
    }

    const observar = async (solicitud: SolicitudInterface) => {
      const { value } = await showPrompt(
        'textarea',
        'Advertencia!',
        `¿Está seguro de observar la solicitud?`,
        'Observar',
        'warning',
      )

      if (value) {
        isLoading.value = true
        const { ok, response } = await store.dispatch('bandejaSolicitud/observarSolicitud', {
          observacion: value,
          solicitudId: solicitud.solicitudId,
        })

        if (ok) {
          obtenerSolicitudes(filtro.value)
          showMessage('Éxito!', response.mensaje, 'success')
        }
        isLoading.value = false
      }
    }

    const notificar = async (solicitud: SolicitudInterface) => {
      const { value } = await showPrompt(
        'textarea',
        'Advertencia!',
        `¿Está seguro de notificar la solicitud?`,
        'Notificar',
        'info',
      )

      if (value) {
        isLoading.value = true
        const { ok, response } = await store.dispatch('bandejaSolicitud/notificar', {
          observacion: value,
          solicitudId: solicitud.solicitudId,
        })

        if (ok) {
          obtenerSolicitudes(filtro.value)
          showMessage('Éxito!', response.mensaje, 'success')
        }
        isLoading.value = false
      }
    }

    const rechazar = async (solicitud: SolicitudInterface) => {
      const { value } = await showPrompt(
        'textarea',
        'Advertencia!',
        `¿Está seguro de rechazar la solicitud?`,
        'Rechazar',
        'danger',
      )

      if (value) {
        isLoading.value = true
        const { ok, response } = await store.dispatch('bandejaSolicitud/rechazarSolicitud', {
          observacion: value,
          solicitudId: solicitud.solicitudId,
        })

        if (ok) {
          obtenerSolicitudes(filtro.value)
          showMessage('Éxito!', response.mensaje, 'success')
        }
        isLoading.value = false
      }
    }

    const enviarTramite = async (solicitud: SolicitudInterface) => {
      const { value } = await confirm(
        `¿Está seguro de enviar a trámite documentario la solicitud N&deg; <b>${solicitud.codigo}</b>?`,
        'success',
      )

      if (value) {
        isLoading.value = true
        const { ok, response } = await store.dispatch('bandejaSolicitud/aprobarSolicitud', solicitud.solicitudId)

        if (ok) {
          obtenerSolicitudes(filtro.value)
          showMessage(
            'Éxito!',
            `Tu solicitud ha sido procesada, tu número de expediente es: <b>${response.numeroExpediente}</b>`,
            'success',
            true,
            false,
          )
        }
        isLoading.value = false
      }
    }

    return {
      credentials: computed(() => store.getters['auth/credentials']),
      enviarTramite,
      filtro,
      isFilterPanelActive,
      isLoading,
      mostrarVerificarModal,
      mostrarEditarModal,
      observar,
      obtenerSolicitudes,
      pagination,
      rechazar,
      filterDate,
      sortColumn,
      ascending,
      solicitudes,
      sortTable,
      verificar,
      verificarModalOnClose,
      editar,
      editarModalOnClose,
      notificar,
      icons: {
        mdiDotsVertical,
        mdiFilterVariantMinus,
        mdiClipboardCheckOutline,
        mdiAlertDecagramOutline,
        mdiCloseOctagonOutline,
        mdiSendOutline,
        mdiFileEditOutline,
        mdiBellRingOutline,
        mdiChevronDown,
        mdiChevronUp,
      },
    }
  },
})
